export default "/images/92743cc5fdffdbcd22f901e68d8dc746.avif";